import { type XmlNodeT, xmlNode } from './xml';

export const BODY_POSITIONS = [
  'Lying',
  'Moving',
  'Seated',
  'Standing',
] as const;

export type BodyPositionT = typeof BODY_POSITIONS[number];

export const DEF_BODY_POSITIONS = 'Body positions taken during wellbeing exercises.';

export function xmlBodyPositions(
  positions: BodyPositionT[],
): XmlNodeT<'body_positions'> {
  return xmlNode('body_positions', positions.join('; '), DEF_BODY_POSITIONS);
}
